import { Duration, durationsToDateAdapter } from '@sequencehq/utils/dates'
import invariant from 'tiny-invariant'

/**
 * Loads the duration of a phase from the start/end dates of phases on the API
 * response. Also, importantly, accounts for the 'MILESTONE' duration which is
 * a special - and somewhat hacky - case.
 * @param param0
 * @returns
 */
export const parseBillingSchedulePhaseDuration = ({
  startDate,
  endDate
}: {
  startDate: Date | undefined
  endDate: Date | undefined
}): 'MILESTONE' | 'OPEN_ENDED' | Duration => {
  /**
   * The open ended case is where the schedule never ends. Therefore, the
   * end date of the open ended phase - which must be the last phase - is
   * undefined.
   */
  if (!endDate) {
    return 'OPEN_ENDED'
  }

  const duration = durationsToDateAdapter.toDuration(startDate)(endDate)

  invariant(duration, 'Duration should be defined')
  /**
   * Milestone billing is a special case where a phase has no defined end
   * date, but may be followed by other phases. We need to distinguish between
   * open ended and milestone because of the aforementioned behaviour differences.
   * The API doesn't support an enum or similar for this, so for now we work
   * around this by converting a MILESTONE phase into a 100 year duration.
   *
   * This is an unreasonably long duration, so is 'safe' for us to use as the
   * replacement for an enum value until we have the API support.
   */
  if (duration?.years === 100) {
    return 'MILESTONE'
  }
  return duration
}
